import { render, staticRenderFns } from "./checkTest.vue?vue&type=template&id=4b98518a&"
import script from "./checkTest.vue?vue&type=script&lang=js&"
export * from "./checkTest.vue?vue&type=script&lang=js&"
import style0 from "./checkTest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b98518a')) {
      api.createRecord('4b98518a', component.options)
    } else {
      api.reload('4b98518a', component.options)
    }
    module.hot.accept("./checkTest.vue?vue&type=template&id=4b98518a&", function () {
      api.rerender('4b98518a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ryProbe/preSale/checkTest.vue"
export default component.exports